export enum BaseCandidatesFiltersEnum {
  branches = 'branches',
  qualificationCategory = 'qualificationCategory',
  active = 'active',
  search = 'search',
}
